import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPracticeOwners } from '../../../../api/Practice';

import { useInfiniteFetchData } from 'lib/hooks/useInfiniteFetchData';

export const usePracticeOwners = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['practice-owners', ...dependencies], () => getPracticeOwners(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5000,
    ...options
  });
};

export const useInfinitePracticeOwners = ({ params = {}, options = {}, dependencies = [] }) => {
  return useInfiniteFetchData({
    queryKey: 'owners',
    url: '/api/practice_owner/get_owners',
    params,
    dependencies,
    options
  });
};
